import styled from "styled-components";

export const Title = styled.div`
  border-bottom: 1px solid #d2d2d2;
  padding: 0 0 5px 0;
  font-weight: 600;
`;

export const FormWrapper = styled.div`
  background: #fff;
  color: #333;
  border-radius: 4px;
  padding: 20px;
  height: fit-content;
  box-shadow: 0 0 15px #dcdcdc;
  font-family: Komet;

  #candidate-page-select {
    margin: 20px 10px;
    padding: 5px;

    &:focus {
      border-color: #79D9D9;
      outline: none;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
    }
  }

  #candidate-page-form-textarea {
    border: 2px solid #e7e7e7;
    border-radius: 4px;
    width: 100%;
    min-height: 8em;
    resize: none;
    padding: 10px;
    margin: 10px 0;

    &:focus {
      border-color: #79D9D9;
      outline: none;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
    }
  }

  #candidate-page-file-input {
    border: 2px solid #e7e7e7;
    border-radius: 4px;
    background-color: #fff;
    width: 100%;
    padding: 10px;
    margin: 10px 0 30px 0;

    &:focus {
      border-color: #79D9D9;
      outline: none;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
    }
  }

  #candidate-page-submit-button {
    font-weight: bold;
    color: #fff;
    background: #79D9D9;
    border: 1px solid #79D9D9;
    box-sizing: border-box;
    border-radius: 4px;
    line-height: 22px;
    color: #fff;
    padding: 10px 12px;
    font-family: Komet;
    text-align: center;
    letter-spacing: 0.03em;
    text-transform: capitalize;
    font-size: 1em;
    min-width: 100px;
    cursor: pointer;
    outline: none;
    transition: 0.15s ease-in-out;

    &:hover {
      color: #fff;
      background: #79D9D9;
      border: 1px solid #79D9D9;
    }

    &:focus {
      background: #402680;
      border: 1px solid #402680;
    }
  }
`;
